import { Button, DraggableWindowHeader } from "@hoylu/client-common";
import React, { useState } from "react";
import { connect } from "react-redux";
import type { RootState } from "typesafe-actions";
import {
  cancelDashboardOption,
  setSearchTerm,
} from "../../state/workspaces/workspaces.actions";
import { Localized } from "../../strings";
import { SearchInput } from "../inputs/SearchInput";
import { Modal } from "./Modal";
import Styles from "./SearchWorkspaceDialog.module.css";

const mapStateToProps = (state: RootState) => ({
  searchTerm: state.context.workspaces.searchTerm,
});

const mapDispatchToProps = {
  cancelDashboardOption,
  setSearchingPhrase: (value: string) => setSearchTerm(value),
};

type SearchWorkspaceDialogProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export const SearchWorkspaceDialog: React.FC<SearchWorkspaceDialogProps> = ({
  cancelDashboardOption,
  setSearchingPhrase,
  searchTerm,
}) => {
  const strings = Localized.object("SEARCH_WORKSPACE_DIALOG");
  const tClose = Localized.object("CLOSE_BUTTON");

  const [term, setTerm] = useState(searchTerm);

  const handleSearch = () => {
    setSearchingPhrase(term);
    cancelDashboardOption();
  };

  return (
    <Modal handleOutsideClick={cancelDashboardOption}>
      <div className={Styles.searchWorkspaceDialog}>
        <DraggableWindowHeader
          close={tClose.CLOSE}
          onClose={cancelDashboardOption}
          title={strings.TITLE}
        />
        <SearchInput handleChange={setTerm} searchTerm={term} />
        <div className={Styles.buttons}>
          <Button
            dataTestId={strings.CANCEL}
            onClick={cancelDashboardOption}
            type="secondary"
          >
            {strings.CANCEL}
          </Button>
          <Button
            dataTestId="set-searching-workspace-term"
            onClick={handleSearch}
            type="primary"
          >
            {strings.SEARCH}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchWorkspaceDialog);
